const NALs = module.exports = {}
NALs.NAL_TYPES = ['NONE', 'P', 'DATAA', 'DATAB', 'DATAC', 'I', 'SEI', 'SPS', 'PPS', 'AUD', 'EOSEQUENCE', 'EOSTREAM', 'FILLER', 'SPSEXT', 'PREFIX', 'SUBSETSPS', 'RESERVED1', 'RESERVED2', 'RESERVED3', 'AUX', 'EXT', 'EXTDPV', 'RESERVED4', 'RESERVED5', '24', '25', '26', '27', '28', '29', '30', '31']
NALs.NAL = Object.fromEntries(NALs.NAL_TYPES.map((v, i)=>[v, i]))

NALs.isVideo = function(nal) {
  return nal && (nal.nal_type === 'I' || nal.nal_type === 'P')
} // isVideo

NALs.findClosestVideoIndex = function(nals, usec) {
  const after_idx = nals.findIndex(nal=>nal.event_dt>=usec && NALs.isVideo(nal))
  let before_idx = after_idx>=0 ? after_idx : nals.length-1
  while(before_idx>=0 && !(nals[before_idx].event_dt<=usec && NALs.isVideo(nals[before_idx]))) before_idx--
  if(after_idx<0) {
    if(before_idx<0) return -1
    return before_idx
  }else if(before_idx<0) {
    return after_idx
  }else if(after_idx===before_idx) {
    return after_idx
  }else {
    const after_diff = Math.abs(nals[after_idx].event_dt-usec)
    const before_diff = Math.abs(nals[before_idx].event_dt-usec)
    return after_diff < before_diff ? after_idx : before_idx
  }
} // findClosestVideoIndex

NALs.moveVideoIndex = function(nals, start_idx, moves=0) {
  if(moves>0) {
    // try to move video frame index forward by `moves` steps
    const max = nals.length-1
    while(start_idx<max && moves>0) {
      let idx = start_idx+1
      while(idx<=max && !NALs.isVideo(nals[idx])) idx++
      if(idx>max) break
      start_idx = idx
      moves--
    }
    return start_idx
  }else if(moves<0) {
    // try to move video frame index backwards by `moves` steps
    moves = -moves
    while(start_idx>0 && moves>0) {
      let idx = start_idx-1
      while(idx>=0 && !NALs.isVideo(nals[idx])) idx--
      if(idx<0) break
      start_idx = idx
      moves--
    }
    return start_idx
  }else {
    return start_idx
  }
} // moveVideoIndex

NALs.findStartBefore = function(nals, start_idx) {
  // find preceding keyframe
  let keyframe_idx = start_idx
  while(keyframe_idx>=0 && nals[keyframe_idx].nal_type!=='I') keyframe_idx--
  if(keyframe_idx<2) return // we still need 2 preceding slots for SPS and PPS

  // find preceding PPS
  let pps_idx = keyframe_idx-1
  while(pps_idx>=0 && nals[pps_idx].nal_type!=='PPS') pps_idx--
  if(pps_idx<1) return // we still need 1 preceding slot for SPS

  // find preceding SPS
  let sps_idx = pps_idx-1
  while(sps_idx>=0 && nals[sps_idx].nal_type!=='SPS') sps_idx--
  if(sps_idx<0) return

  return { sps_idx, pps_idx, keyframe_idx }
} // findStartBefore

NALs.findStartAfter = function(nals, start_idx) {
  const last = nals.length-1
  // find following SPS
  let sps_idx = start_idx
  while(sps_idx<last && nals[sps_idx]!=='SPS') sps_idx++
  if(sps_idx>=last) return

  // find following PPS
  let pps_idx = sps_idx+1
  while(pps_idx<last && nals[pps_idx]!=='PPS') pps_idx++
  if(pps_idx>=last) return

  // find following keyframe
  let keyframe_idx = pps_idx+1
  while(keyframe_idx<=last && nals[keyframe_idx]!=='I') keyframe_idx++
  if(keyframe_idx>last) return

  return { sps_idx, pps_idx, keyframe_idx }
} // findStartAfter
